import { render, staticRenderFns } from "./PartnerAppointmentRecallForm.vue?vue&type=template&id=6732bc33"
import script from "./PartnerAppointmentRecallForm.vue?vue&type=script&lang=ts"
export * from "./PartnerAppointmentRecallForm.vue?vue&type=script&lang=ts"
import style0 from "./PartnerAppointmentRecallForm.vue?vue&type=style&index=0&id=6732bc33&prod&lang=sass"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports